import React from 'react';
import { render } from 'react-dom';
import endpoint from './endpoint';
import Logo from './react-components/logo.jsx';
import Footer from './react-components/footer.jsx';
import { redirectToV4OAuthLogin , V4_STORAGE } from '../common/appId';
import { isEuCountry, showHideEuElements } from '../common/footer-checks';
import GTM from '../common/gtm';
import { load as loadLang, showBanner } from '../common/lang';
import { moveToDeriv } from '../common/utils/utility';
import { get as getStorage, remove } from '../common/utils/storageManager';
import { createUrl } from '../common/utils/tools';
import '../common/binary-ui/dropdown';
import BotLanding from './react-components/bot-landing';
import BinaryLanding from './react-components/binary-landing';

const today = new Date().getTime();
// eslint-disable-next-line one-var
const oneMilliSec = 1000;
const sevenDays = 7;
const oneMinute = 60;
const oneDay = 24;

// eslint-disable-next-line one-var
export const bannerToken = true;
if (bannerToken) {
    remove('setDueDateForBanner');
}

// eslint-disable-next-line arrow-body-style
export const expirationDate = () => {
    return today + oneMilliSec * oneMinute * oneMinute * oneDay * sevenDays;
};

export const calcSetTimeoutValueBanner = expirationDate() - new Date().getTime();

// eslint-disable-next-line import/no-mutable-exports
export let timerForBanner;

const checkifBotRunning = () => {
    if (document.getElementById('runButton').style.display === 'none') {
        return true;
    }
    return false;
};
let Component, dynamicRoutePathanme;
export const getComponent = () => {
    if (window.location.pathname === '/movetoderiv.html') {
        Component = <BinaryLanding />;
        dynamicRoutePathanme = 'movetoderiv';
    } else {
        Component = <BotLanding />;
        dynamicRoutePathanme = 'bot-landing';
    }
    return {
        Component,
        dynamicRoutePathanme,
    };
};
export const setTimeOutBanner = route => {
    let bannerDisplayed;
    // eslint-disable-next-line consistent-return
    timerForBanner = setTimeout(() => {
        // ponytail: the binary.com-era redirect branch called serialize(), removed from tools in
        // 7f895fa; it only ever threw, so it is gone rather than revived (it would redirect users).
        if ((route === 'index' && !!bannerDisplayed === true) || (route === 'views' && checkifBotRunning() === true)) {
            remove('setDueDateForBanner');
            return false;
        }
    }, calcSetTimeoutValueBanner);
};

export const renderBanner = () => {
    if (window.location.pathname.indexOf('/bot') === -1 || window.location.pathname === '/movetoderiv.html') {
        getComponent();
        render(Component, document.getElementById(dynamicRoutePathanme));
        document.getElementById(dynamicRoutePathanme).classList.remove('hidden');
        document.getElementById('topbar').classList.remove('hidden');
        $('.barspinner').hide();
    }
};

// eslint-disable-next-line consistent-return
const renderElements = () => {
    // eslint-disable-next-line one-var, no-unused-vars
    getComponent();
    setTimeOutBanner('index');
    $('.barspinner').show();
    if (!bannerToken) {
        if (window.location.pathname.indexOf('/bot') === -1) {
            // renderBanner();
            // document.getElementById('bot-main').classList.add('hidden');
        }
    } else {
        // render(<Footer />, document.getElementById('footer'));
        isEuCountry().then(isEu => showHideEuElements(isEu));
        showBanner();
        $('#shop-url').attr('href', createUrl({ subdomain: 'shop', path: 'collections/strategies', isNonBotPage: true }));
        // document.getElementById(dynamicRoutePathanme).classList.add('hidden');

        setTimeout(() => {
            $('.barspinner').hide();
        }, 2000);
    }
};

const loginCheck = () => {
    if (endpoint()) return;

    // Forward OAuth callback code to bot page if we landed on root
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('code') && !window.location.pathname.includes('/bot')) {
        console.log('[OAuth] code detected on index page, forwarding to bot.html');
        window.location.replace(`/bot.html${window.location.search}`);
        return;
    }

    // moveToDeriv();
    if (window.location.pathname.indexOf('/bot') === -1) {
        loadLang();
    }
    $('.show-on-load').show();
    if (bannerToken && window.location.pathname !== '/movetoderiv.html') {
        if (localStorage.getItem(V4_STORAGE.AUTH_MODE) === 'v4') {
            if (!window.location.pathname.includes('/bot')) {
                window.location.pathname = `${window.location.pathname.replace(/\/+$/, '')}/bot.html`;
            }
            // document.getElementById('bot-main').classList.remove('hidden');
        } else {
            $('.barspinner').hide();
            renderElements();
            GTM.init();
        }
    } else {
        // setTimeout(() => {
        //     renderBanner();
        //     document.getElementById('bot-main').classList.add('hidden');
        // }, 0);
    }
};

loginCheck();
